export function toUserInfoStatusSelectItem(item) {
  return {
    label: item.value,
    value: item.id,
  }
}

export function toUserInfoStatusSelectItems(
  items,
  mapper = toUserInfoStatusSelectItem
) {
  return items.map(mapper)
}
